import ResponseSystemError from './errors/ResponseSystemError';
import ResponseConnectionErrorChannel from './errors/ResponseConnectionErrorChannel';

import store from '@/store';

export const handleResponse = (res) => res.data;

export const handleError = (err) => {
  if (err instanceof ResponseSystemError) {
    const { cause } = err.errors;
    const errorMessage = mapErrors[cause] || cause;

    showAlterts(errorMessage);
    return;
  }

  if (err instanceof ResponseConnectionErrorChannel) {
    const { reason } = err.errors;
    const { channel } = err;
    const errorMessage = mapErrors[reason] || reason;

    // showAlterts(`connectionErrorChannel.${channel}.${errorMessage}`)
    return;
  }

  console.log(err);
  showAlterts('triggerActiveJobError');
};

const showAlterts = (message) => {
  store.dispatch('showSnackbar', { text: message, type: 'error' });
};

const mapErrors = {
  pause: 'cannotActiveJobBecauseInPause',
};
